import * as React from "react"
import { IconProps } from "./IconProps"

export const FastBackward = (props: IconProps) => {
  const { color = "currentColor" } = props

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5626_11553)">
        <path d="M18.41 16.59L13.82 12L18.41 7.41L17 6L11 12L17 18L18.41 16.59ZM6 6H8L8 18H6L6 6Z" fill={color} />
      </g>
    </svg>
  )
}
